var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 635,
    height: 175,
    viewBox: "0 0 635 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635 151H571.5L635 214.5V151Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.528 151.028C479.114 152.032 506.968 179.886 507.972 214.472C473.386 213.468 445.532 185.614 444.528 151.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.25 151C204.715 151 190.5 165.215 190.5 182.75C190.5 200.285 204.715 214.5 222.25 214.5C239.785 214.5 254 200.285 254 182.75C254 165.215 239.785 151 222.25 151Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.528 87.5277C606.114 88.5316 633.968 116.386 634.972 150.972C600.386 149.968 572.532 122.114 571.528 87.5277Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 151H571.5V87.5H508V151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.75 87.5C395.215 87.5 381 101.715 381 119.25C381 136.785 395.215 151 412.75 151C430.285 151 444.5 136.785 444.5 119.25C444.5 101.715 430.285 87.5 412.75 87.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 87.5H317.5L381 151V87.5Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 87.5C268.215 87.5 254 101.715 254 119.25C254 136.785 268.215 151 285.75 151C303.285 151 317.5 136.785 317.5 119.25C317.5 101.715 303.285 87.5 285.75 87.5Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 87.5H127L190.5 151V87.5Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 24C268.215 24 254 38.215 254 55.75C254 73.285 268.215 87.5 285.75 87.5C303.285 87.5 317.5 73.285 317.5 55.75C317.5 38.215 303.285 24 285.75 24Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508 24H571.5V-39.5H508V24Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.25 -39.5C458.715 -39.5 444.5 -25.285 444.5 -7.75C444.5 9.78504 458.715 24 476.25 24C493.785 24 508 9.78504 508 -7.75C508 -25.285 493.785 -39.5 476.25 -39.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.028 -39.4713C415.614 -38.4675 443.468 -10.6134 444.472 23.9727C409.886 22.9688 382.032 -4.88531 381.028 -39.4713Z",
    fill: "#9ACDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 -39.5H317.5L381 24V-39.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 635,
    height: 381,
    fill: "white",
    transform: "translate(635 278) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.5edd3263.svg";
export { ForwardRef as ReactComponent };